import React, { useState, useEffect } from 'react';
import axios from 'axios';

function APIThreeForm() {
  const [inputs, setInputs] = useState({
    brand_name: '',
    date: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [apiEndpoint, setApiEndpoint] = useState('');

  useEffect(() => {
    const fetchApiEndpoint = async () => {
      try {
        const res = await axios.get('/wp-json/custom/v1/options');
        setApiEndpoint(res.data.fuselight_api_3_testing);
      } catch (error) {
        console.error('Error fetching API endpoint:', error);
      }
    };

    fetchApiEndpoint();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    console.log('Sending data:', inputs);
    setResults([]);
    setErrorMessage('');
    try {
      const res = await axios.post(
        '/wp-json/custom/v1/proxy',
        {
          url: apiEndpoint,
          data: inputs
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('Received data:', res.data);
      setResults(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      const message =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : 'Failed to fetch data. Please try again later.';
      setErrorMessage(`Error: ${message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            name="brand_name"
            value={inputs.brand_name}
            onChange={handleChange}
            placeholder="Brand Name"
          />
          <input
            type="text"
            name="date"
            value={inputs.date}
            onChange={handleChange}
            placeholder="Date (YYYY-MM-DD)"
          />
        </div>
        <div className="form-row">
          <button type="submit">Submit</button>
        </div>
      </form>
      {isLoading && <div className="loading-message">Loading...</div>}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <div className="results-section">
        {results && results.mentions && (
          <div>
            <h3>Results</h3>
            <p>
              Mentions: <strong>{results.mentions}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default APIThreeForm;
